import { render, staticRenderFns } from "./TaskFilters.vue?vue&type=template&id=488a8c2a&scoped=true"
import script from "./TaskFilters.vue?vue&type=script&lang=js"
export * from "./TaskFilters.vue?vue&type=script&lang=js"
import style0 from "./TaskFilters.vue?vue&type=style&index=0&id=488a8c2a&prod&scoped=true&lang=css"
import style1 from "./TaskFilters.vue?vue&type=style&index=1&id=488a8c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488a8c2a",
  null
  
)

export default component.exports